import React from 'react'

import { Box, Color, Display, FlexDirection, Space } from '@gousto-internal/citrus-react'

import { MenuApiPreferencesResponse, RecipeUUID } from '@library/menu-service'

import { useGroups } from 'hooks/menu-groups/useGroups'

import { Carousel } from './Carousel'
import { RecipeGroupingRecipe } from './RecipeGroupingRecipe'
import { RecipeGroupingTitle } from './RecipeGroupingTitle'

type RecipeGroupingsProps = {
  menuPreferences?: MenuApiPreferencesResponse
}

export const RecipeGroupings = ({ menuPreferences }: RecipeGroupingsProps) => {
  const groups = useGroups()

  return (
    <Box display={Display.Flex} flexDirection={FlexDirection.Column} gap={4}>
      {Object.entries(groups).map(([key, group]) => (
        <Box
          key={key}
          bg={group.displayType === 'highlight' ? Color.ColdGrey_800 : undefined}
          borderRadius={1.5}
          paddingH={4}
          paddingV={4}
        >
          <RecipeGroupingTitle
            color={group.displayType === 'highlight' ? Color.White : undefined}
            description={group.description}
            title={group.title}
          />
          <Space size={1} />
          <Carousel>
            {group.recipes.map((recipe) => (
              <RecipeGroupingRecipe
                key={recipe.id}
                id={recipe.id as RecipeUUID}
                menuPreferences={menuPreferences}
              />
            ))}
          </Carousel>
        </Box>
      ))}
    </Box>
  )
}
